<!-- Translated: yes -->
<template>
  <div class="">

    <header>
      <slot name="header"></slot>
    </header>

    <main>
      <slot></slot>
    </main>

    <footer>
      <slot name="footer"></slot>
    </footer>

  </div>

</template>

<script>
export default {
  props: {
  },
  components: {
  },
  methods: {
  },
};
</script>

<style lang="stylus" scoped>



// WEBPACK FOOTER //
// ModalFaker.vue?3b1b412e